module.exports = __webpack_public_path__ + "static/media/42x38-4.a5da57ce.png";